import { FC } from "react";

interface ConfirmDeletePopUpProps {
   
    id: string;    
    text: string;
    page:string;
    onDelete: (id: string) => void;
    onCancel: () => void;  
}

export const ConfirmDeletePopUp: FC<ConfirmDeletePopUpProps> = ({id,text,page, onDelete, onCancel }) => {


    const clearAndCloseConfirmDeletePopup = () => {
        onCancel();
    }
    const deleteHander = onDelete;
            
    //Render
    return(
        <div className="deletePopUp">            
           <span>{text}</span>
           <div className="formfooter">  
                    <auro-button id="btnCancel" slim slot="trigger"  onClick={ () => clearAndCloseConfirmDeletePopup()}>
                        No
                    </auro-button>
                <auro-button
                    secondary 
                    slim
                    onClick={ () => deleteHander(id)}>
                        Yes
                </auro-button>
            </div>                      
        </div>
    )
}


